var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkthree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4158 3.98999H4.45581C3.35856 3.98999 2.47079 4.88774 2.47079 5.98498L2.46082 17.955C2.46082 19.0522 3.35856 19.9499 4.45581 19.9499H20.4158C21.513 19.9499 22.4108 19.0522 22.4108 17.955V5.98498C22.4108 4.88774 21.513 3.98999 20.4158 3.98999ZM20.4158 17.955H4.45581V7.97998L12.4358 12.9675L20.4158 7.97998V17.955ZM12.4358 10.9725L4.45581 5.98498H20.4158L12.4358 10.9725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkthree);
export default __webpack_public_path__ + "static/media/linkthree.0d70414c29ede2ea862053d60a9c0fa9.svg";
export { ForwardRef as ReactComponent };